/**
 * Footer V2 runtime.
 * Copied from v1 footer behavior in `assets/theme.js.liquid` (`FacetFloatingFilter`),
 * scoped to `.shopify-section--footer-v2` so v1 `.shopify-section--footer` is untouched.
 */

const FOOTER_V2_MOUNTED = 'footerV2Mounted';
const FILTER_HIDE_DURATION_MS = 150;

/**
 * @param {HTMLElement} element
 * @param {boolean} isHidden
 */
function setFloatingFilterVisibility(element, isHidden) {
  if (isHidden) {
    element.animate(
      [
        { opacity: 1, transform: 'translateY(0px)', visibility: 'visible' },
        { opacity: 0, transform: 'translateY(15px)', visibility: 'hidden' },
      ],
      { duration: FILTER_HIDE_DURATION_MS, fill: 'forwards' }
    );
    return;
  }

  element.animate(
    [
      { opacity: 0, transform: 'translateY(15px)', visibility: 'hidden' },
      { opacity: 1, transform: 'translateY(0px)', visibility: 'visible' },
    ],
    { duration: FILTER_HIDE_DURATION_MS, fill: 'forwards' }
  );
}

/**
 * Hides collection floating filters when Footer V2 enters the viewport.
 * @param {Element} footerSection
 */
function bindFacetFloatingFilters(footerSection) {
  const filters = document.querySelectorAll('facet-floating-filter');
  if (!filters.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      const isIntersecting = Boolean(entries[0]?.isIntersecting);
      filters.forEach((filter) => {
        if (filter instanceof HTMLElement) {
          setFloatingFilterVisibility(filter, isIntersecting);
        }
      });
    },
    { rootMargin: '50px 0px' }
  );

  observer.observe(footerSection);
}

/**
 * Marks the section as mounted so Shopify section reloads can re-init cleanly.
 * @param {HTMLElement} root
 */
function initFooterV2(root) {
  if (!root || root.dataset[FOOTER_V2_MOUNTED] === 'true') return;

  bindFacetFloatingFilters(root);
  root.dataset[FOOTER_V2_MOUNTED] = 'true';
}

document.querySelectorAll('.shopify-section--footer-v2').forEach((section) => {
  if (section instanceof HTMLElement) initFooterV2(section);
});
